var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pull-right"},[_c('div',{staticClass:"header-inner"},[_c('a',{staticClass:"btn-link icon-set menu-hambuger-plus m-l-20 sm-no-margin hidden-sm hidden-xs",attrs:{"href":"#","data-toggle":"quickview","data-toggle-element":"#quickview"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-338f7972","hasScoped":false,"transformToRequire":{"img":["src","data-src","data-src-retina"]},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Header/QuickviewToggle.vue
// module id = 1807
// module chunks = 0